import { render } from "./ModuleRedesignation.vue?vue&type=template&id=53581630"
import script from "./ModuleRedesignation.vue?vue&type=script&lang=js"
export * from "./ModuleRedesignation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__